import { Grid2, FormControl, Button } from '@mui/material';
import { FieldWithInlineEdit, FieldWithInlineEditApi, IComponentCss, MdEditor, MdView } from '@tap/mui-ui';
import Editor from 'react-markdown-editor-lite';
import { useState, useRef, useEffect } from 'react';

/*
*   Редактор с кнопками
*/


const css: IComponentCss = {
    editorWrap: {
        border: '0px solid #E0E0E0',
        borderRadius: '4px',
        marginTop: '6px',
        width: '100%',
        zIndex: 1,
    },
    buttonsWrap: {
        marginTop: '12px',
        width: '100%',
        justifyContent: 'flex-end',
    },
    button: {
        textTransform: 'none',
    },
    buttonSend: {
        marginRight: '10px',
    },
}

export type DescriptionEditorProps = {
    disabled?: boolean,
    initialValue: string,
    onSave: (text: string) => void,
    onChange?: (text: string) => void,
    editorRef?: React.MutableRefObject<Editor | null>,
    saveDisabled?: boolean,
}

export function DescriptionEditor({ disabled = false, initialValue, onSave, onChange, editorRef, saveDisabled }: DescriptionEditorProps) {
    const [description, setDescription] = useState<string>(initialValue);

    const fieldRef = useRef<FieldWithInlineEditApi>();

    const handleChange = (text: string) => {
        onChange && onChange(text)
        setDescription(text);
    }

    const handleBlur = () => {
        if (saveDisabled) {
            handleChange(initialValue);
            return;
        }

        onSave(description)
    }

    useEffect(() => {
        setDescription(initialValue ?? '');
    }, [initialValue])

    return (
        <FieldWithInlineEdit
            md={12}
            fieldRef={fieldRef}
            onBlur={() => handleBlur()}
            view={<MdView mdContent={initialValue || 'Добавить описание...'} />}
            edit={!disabled
                ? <Grid2
                    container
                    sx={css.editorWrap}
                    justifyContent='flex-end'
                >
                    <FormControl fullWidth>
                        <MdEditor
                            editorRef={editorRef}
                            value={description}
                            onChange={({ text }) => handleChange(text)}
                            style={
                                saveDisabled
                                    ? { border: '2px solid #d32f2f' }
                                    : {}
                            }
                        />
                    </FormControl>
                    <Grid2
                        container
                        sx={css.buttonsWrap}
                    >
                        <Button
                            variant='contained'
                            disableElevation
                            sx={{ ...css.button, ...css.buttonSend }}
                            onClick={() => {
                                onSave(description)
                                fieldRef.current?.blur()
                            }}
                            disabled={saveDisabled}
                        >
                            Сохранить
                        </Button>
                        <Button
                            variant='text'
                            sx={css.button}
                            onClick={() => {
                                handleChange(initialValue);
                                fieldRef.current?.blur()
                            }}
                        >
                            Отмена
                        </Button>
                    </Grid2>
                </Grid2>
                : undefined
            }
        />
    );
}
